import { GroupItem } from "devextreme-react/form";
import { DropDownOptions } from "devextreme-react/drop-down-box";
import { Form, SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DropDownGrid } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { textEditorOptions } from "../../utils/helpers";
import { CreateEmailTemplate, EmailTemplateTypes } from "./type";

const createEmailTemplateForm = forwardRef<any, { data: CreateEmailTemplate }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized)
    const { token, lang } = useSelector(getApiParams);
    const [emailTemplateType, setEmailTemplateType] = useState<EmailTemplateTypes[]>([])
    const [, setId] = useState();

    const getEmailTemplateTypes = useCallback((async () => {
        const response: ApiResponse<EmailTemplateTypes[]> = await createRequest({
            method: "GET",
            url: "/api/admin/emailtemplates/get-email-template-types",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setEmailTemplateType(response.Result)
        }
    }), [token, lang])

    useEffect(() => {
        getEmailTemplateTypes();
    }, [getEmailTemplateTypes])
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                editorType={"dxTextBox"}
                editorOptions={{
                    inputAttr: {
                        style: " text-transform: capitalize",
                    },
                }}
                label={{ text: localize.getString("name") }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Template"}
                editorType={"dxHtmlEditor"}
                editorOptions={textEditorOptions}
                label={{ text: localize.getString("template") }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Active"}
                editorType={"dxCheckBox"}
                label={{ text: localize.getString("isActive") }}
            >

            </SimpleItem>
            <SimpleItem
                dataField="EmailTemplateTypeId"
                editorType="dxLookup"
                label={{ text: localize.getString("emailTemplateType") }}
                render={(item: any) => (
                    <DropDownGrid
                        dataSource={emailTemplateType}
                        columns={["Code", "Name"]}
                        displayExpr="Name"
                        returnSelectedId={async (id: any) => {
                            console.log(item)
                            item.editorOptions.value = id
                            data.EmailTemplateTypeId = id
                            setId(id);
                        }}

                        value={data.EmailTemplateTypeId}
                        dropDownOptions={{ width: 500 }}
                    />
                )}
            >
                <DropDownOptions closeOnOutsideClick showTitle={false} />
            </SimpleItem>
        </GroupItem>

    </Form>
})

export default createEmailTemplateForm